import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../lib/api";
import Logo from "../../components/Logo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-5 grain" data-testid="admin-login-page">
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand/20 rounded-full blur-[120px]" />
      <div className="w-full max-w-md relative">
        <div className="flex flex-col items-center mb-8">
          <Logo variant="light" />
          <p className="text-white/50 mt-4">Espace administration</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-3xl p-8 shadow-2xl space-y-5">
          {error && <div data-testid="login-error" className="bg-red-50 text-red-600 text-sm font-medium px-4 py-3 rounded-xl">{error}</div>}
          <label className="block">
            <span className="text-sm font-semibold text-navy mb-1.5 block">Email</span>
            <div className="relative">
              <Mail className="w-5 h-5 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full py-3.5 pl-11 pr-4 bg-surface border border-border rounded-xl focus:outline-none focus:ring-2 focus:ring-brand" placeholder="admin@ms-energie.fr" />
            </div>
          </label>
          <label className="block">
            <span className="text-sm font-semibold text-navy mb-1.5 block">Mot de passe</span>
            <div className="relative">
              <Lock className="w-5 h-5 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full py-3.5 pl-11 pr-4 bg-surface border border-border rounded-xl focus:outline-none focus:ring-2 focus:ring-brand" placeholder="••••••••" />
            </div>
          </label>
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-brand hover:bg-brand-dark text-white font-bold py-4 rounded-full flex items-center justify-center gap-2 transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
